import moment from "moment/moment";
import {
	defaultTimeForEnd,
	defaultTimeForStart
} from "@/components/Fleet/WorkOrdersStatistics/Planer/SplitRepairs/constants";

export default function getFormattedDate(date) {
	let formattedDate = '';
	const [ dateValue, ] = date.split(' ');
	const isValidTimeStart = moment(`${ dateValue } ${ defaultTimeForStart }`).isBefore(date);
	const isValidTimeEnd = moment(`${ dateValue } ${ defaultTimeForEnd }`).isAfter(date);

	if (isValidTimeStart && isValidTimeEnd) {
		formattedDate = date;
	} else {
		formattedDate = !isValidTimeStart ? `${ dateValue } ${ defaultTimeForStart }` : `${ dateValue } ${ defaultTimeForEnd }`;
	}

	return formattedDate;
}
